<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="'ZURUECK' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ 'ADRESSBUCH' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="padding-16">
    @if (canReadPersonnelDossier$ | async) {
      <div class="margin-bottom-24">
        <work-ui-button text="PERSONALDOSSIER" routerLink="personaldossier" [fullWidth]="true" />
      </div>
    }

    <div class="flex flex-column gap-16">
      @if (user(); as user) {
        <div class="flex flex-column center gap-16">
          <work-ui-avatar size="huge"
                          [imgSrc]="user.userImage ? (user.userImage.fileSrcThumbnail | prependServerToFileSrc) : null" />
          <div class="work-text-align-center">
            <h1>{{ user.firstName + ' ' + user.lastName }}</h1>
            @if (user.jobtitle) {
              <p>{{ user.jobtitle }}</p>
            }
            @if (user.businessunit?.city) {
              <p>{{ user.businessunit?.city }}</p>
            }
          </div>
        </div>

        @if (user.absences && user.absences.length > 0) {
          <div class="padding-16 work-text-align-center">
            <p class="work-color-warning">
              <work-ui-icon name="close" />
              <span>{{ 'ABWESEND_BIS_DATUM' | translate: { date: user.absences[0].end } }}</span>
            </p>
          </div>
        }

        @if (user.supervisor) {
          <div class="flex flex-column">
            <p>{{ 'VORGESETZTER' | translate }}</p>
            <h2>{{ user.supervisor.firstName }} {{ user.supervisor.lastName }}</h2>
          </div>
          <hr>
        }

        @if (user.phone) {
          <div class="flex flex-row space-between vertical-center">
            <div>
              <p>{{ 'TELEFON_GESCHAEFT' | translate }}</p>
              <h2>{{ user.phone }}</h2>
            </div>
            <div class="work-buttons">
              <work-ui-button iconName="phone" [iconOnly]="true" (click)="call(user.phone)" />
              @if (isSwissMobilePhoneNumber(user.phone)) {
                <work-ui-button iconExternalSrc="assets/svg/whatsapp.svg" [iconOnly]="true"
                                (click)="openWhatsApp(user.phone)" />
                <work-ui-button iconName="sms" [iconOnly]="true" (click)="sendSMS(user.phone)" />
              }
            </div>
          </div>
          <hr>
        }

        @if (user.mobileprivate) {
          <div class="flex flex-column gap-8">
            <div class="flex flex-row space-between vertical-center">
              <div>
                <p>{{ 'MOBILE_PRIVAT' | translate }}</p>
                <h2>{{ user.mobileprivate }}</h2>
              </div>
              <div class="work-buttons">
                <work-ui-button iconName="phone" [iconOnly]="true" (click)="call(user.mobileprivate)" />
                <work-ui-button iconExternalSrc="assets/svg/whatsapp.svg" [iconOnly]="true"
                                (click)="openWhatsApp(user.mobileprivate)" />
                <work-ui-button iconName="sms" [iconOnly]="true" (click)="sendSMS(user.mobileprivate)" />
              </div>
            </div>
            <p class="work-color-danger work-text-small">{{ 'PRIVATNUMMER_NICHT_WEITERGEBEN' | translate }}</p>
          </div>
          <hr>
        }

        @if (user.email) {
          <div class="flex flex-row space-between vertical-center">
            <div>
              <p>{{ 'EMAIL_GESCHAEFT' | translate }}</p>
              <h2>{{ user.email }}</h2>
            </div>
            <div class="work-buttons">
              <work-ui-button iconName="mail" [iconOnly]="true" (click)="createMail(user.email)" />
            </div>
          </div>
          <hr>
        }

        @if (user.emailprivate) {
          <div class="flex flex-row space-between vertical-center">
            <div>
              <p>{{ 'EMAIL_PRIVAT' | translate }}</p>
              <h2>{{ user.emailprivate }}</h2>
            </div>
            <div class="work-buttons">
              <work-ui-button iconName="mail" [iconOnly]="true" (click)="createMail(user.emailprivate)" />
            </div>
          </div>
          <hr>
        }

        @if (user.street && user.city) {
          <div class="flex flex-row space-between vertical-center">
            <div>
              <p>{{ 'ADRESSE_PRIVAT' | translate }}</p>
              <h2>{{ user.firstName }} {{ user.lastName }}</h2>
              <h2>{{ user.street }}</h2>
              <h2>{{ user.city }}</h2>
            </div>
            <div class="work-buttons">
              <work-ui-button iconName="map" [iconOnly]="true" (click)="openGoogleMaps()" />
            </div>
          </div>
          <hr>
        }

        @if (user.birthdate) {
          <div class="flex flex-column">
            <p>{{ 'GEBURTSDATUM' | translate }}</p>
            <h2>{{ user.birthdate | formatDate }}</h2>
          </div>
          <hr>
        }

        @if (user.emergencycontact) {
          <div class="flex flex-column">
            <p>{{ 'NOTFALLKONTAKT' | translate }}</p>
            <h2>{{ user.emergencycontact }}</h2>
          </div>
          <hr>
        }

        @if (user.employmentType) {
          <div class="flex flex-column">
            <p>{{ 'ANSTELLUNG' | translate }}</p>
            <h2>{{ user.employmentType }}</h2>
          </div>
          <hr>
        }

        @if (user.workload) {
          <div class="flex flex-column">
            <p>{{ 'PENSUM' | translate }}</p>
            <h2>{{ user.workload }}%</h2>
          </div>
          <hr>
        }

        @if (user.entrydate) {
          <div class="flex flex-column">
            <p>{{ 'ANGESTELLT_SEIT' | translate }}</p>
            <h2>{{ user.entrydate | formatDate }}</h2>
          </div>
          <hr>
        }
      }
    </div>
  </div>
</ion-content>
